// client/src/components/Admin/RegistrationInfoModal.js
import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";

// Material UI Components
import Slide from "@material-ui/core/Slide";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";

// Styles
import stylesModal from "assets/jss/material-dashboard-pro-react/views/notificationsStyle.js";
import { cardTitle } from "assets/jss/material-dashboard-pro-react.js";

const stylesCard = {
  cardTitle: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px",
    textAlign: "center",
  },
  infoLabel: {
    fontWeight: "600",
    fontSize: "16px",
    color: "#3C4858",
    marginBottom: "8px",
    textAlign: "center",
  },
  infoContent: {
    fontSize: "15px",
    color: "#555555",
    marginBottom: "20px",
    textAlign: "center",
    lineHeight: "1.5",
  },
};

const useStylesModal = makeStyles(stylesModal);
const useStylesCard = makeStyles(stylesCard);

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

const RegistrationInfoModal = ({ open, onClose, registrationData }) => {
  const classesModal = useStylesModal();
  const classesCard = useStylesCard();
  const classes = { ...classesModal, ...classesCard };

  if (!registrationData) return null;

  return (
    <Dialog
      classes={{
        root: classes.center + " " + classes.modalRoot,
        paper: classes.modal,
      }}
      open={open}
      TransitionComponent={Transition}
      keepMounted
      onClose={onClose}
      aria-labelledby="registration-info-modal-title"
      aria-describedby="registration-info-modal-description"
    >
      <DialogTitle
        id="registration-info-modal-title"
        disableTypography
        className={classes.modalHeader}
      >
        <span className={classes.modalTitle}>Registration Information</span>
      </DialogTitle>
      <DialogContent
        id="registration-info-modal-description"
        className={classes.modalBody}
      >
        <div>
          <GridContainer>
            <GridItem xs={12} sm={12} md={12}>
              <div className={classes.infoLabel}>Name</div>
              <div className={classes.infoContent}>{registrationData.name}</div>
            </GridItem>

            <GridItem xs={12} sm={12} md={12}>
              <div className={classes.infoLabel}>Email</div>
              <div className={classes.infoContent}>
                {registrationData.email}
              </div>
            </GridItem>

            <GridItem xs={12} sm={12} md={12}>
              <div className={classes.infoLabel}>Institution</div>
              <div className={classes.infoContent}>
                {registrationData.institution}
              </div>
            </GridItem>

            <GridItem xs={12} sm={12} md={12}>
              <div className={classes.infoLabel}>Role</div>
              <div className={classes.infoContent}>{registrationData.role}</div>
            </GridItem>

            <GridItem xs={12} sm={12} md={12}>
              <div className={classes.infoLabel}>Registration Type</div>
              <div className={classes.infoContent}>
                {registrationData.registration_type}
              </div>
            </GridItem>

            {registrationData.confirmation_code && (
              <GridItem xs={12} sm={12} md={12}>
                <div className={classes.infoLabel}>Confirmation Code</div>
                <div className={classes.infoContent}>
                  {registrationData.confirmation_code}
                </div>
              </GridItem>
            )}

            <GridItem xs={12} sm={12} md={12}>
              <div className={classes.infoLabel}>Need Agenda Time</div>
              <div className={classes.infoContent}>
                {registrationData.need_time ? "Yes" : "No"}
              </div>
            </GridItem>

            {registrationData.need_time && registrationData.agenda_time && (
              <GridItem xs={12} sm={12} md={12}>
                <div className={classes.infoLabel}>Requested Agenda Time</div>
                <div className={classes.infoContent}>
                  {registrationData.agenda_time} minutes
                </div>
              </GridItem>
            )}

            {registrationData.need_time && registrationData.agenda_topic && (
              <GridItem xs={12} sm={12} md={12}>
                <div className={classes.infoLabel}>Agenda Topic</div>
                <div className={classes.infoContent}>
                  {registrationData.agenda_topic}
                </div>
              </GridItem>
            )}
          </GridContainer>
        </div>
      </DialogContent>
      <DialogActions
        className={classes.modalFooter + " " + classes.modalFooterCenter}
      >
        <Button onClick={onClose} color="rose" round>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

RegistrationInfoModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  registrationData: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    name: PropTypes.string,
    email: PropTypes.string,
    institution: PropTypes.string,
    role: PropTypes.string,
    registration_type: PropTypes.string,
    confirmation_code: PropTypes.string,
    need_time: PropTypes.bool,
    agenda_time: PropTypes.string,
    agenda_topic: PropTypes.string,
  }),
};

export default RegistrationInfoModal;

